import { Box, Stack, Typography } from "@mui/material";
import { ReactNode } from "react";

type Props = {
  name: string;
  subtitle: string;
  icon: ReactNode;
  highlightName?: boolean;
};

export default function IntakeFormHeader({
  name,
  icon,
  subtitle,
  highlightName,
}: Props) {
  return (
    <Stack
      direction="column"
      sx={{
        justifyContent: "start",
        overflow: "hidden",
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "row" }}>
        {icon || <Box sx={{ width: 24, height: 24 }} />}
        <Typography
          variant="subtitleDefault"
          noWrap
          sx={{
            color: highlightName ? "text.primary" : "text.secondary",
            ml: 1,
          }}
        >
          {name}
        </Typography>
      </Box>
      <Typography
        variant="paragraphSmall"
        noWrap
        sx={{
          ml: 4,
          color: "secondary.main",
          flexBasis: "100%",
        }}
      >
        {subtitle}
      </Typography>
    </Stack>
  );
}
